import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=0f2d2e3e&"
import script from "./ReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./ReviewDialog.vue?vue&type=style&index=1&id=0f2d2e3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports